module.exports = __webpack_public_path__ + "static/profile-cba429d9358689b7c8d187ea54cef76f.jpg";